export enum LaunchMetricsKey {
  START_TIMESTAMP = 'start-timestamp',
  HSR_GET_IMAGE_DATA_COST = 'hsr-getImageData-cost',
  BOOTSTRAP_START = 'bootstrap-start',
  BOOTSTRAP_COST = 'bootstrap-cost',
  WAIT_LOGIN_CHECK = 'wait-login-check',
  MAIN_START = 'main-start',
  BIZ_EXEC_START = 'biz-exec-start',
  BIZ_START = 'biz-start',
  BIZ_RESOURCE_LOAD_START = 'biz-resource-load-start',
  BIZ_RESOURCE_LOAD_COST = 'biz-resource-load-cost',
  BIZ_RESOURCE_FETCH_COST = 'biz-resource-fetch-cost',
  ADAPTER_LOAD_COST = 'adapter-load-cost',
  NAV_RENDER_START = 'nav-render-start',
  SECOND_NAV_RENDER_START = 'second-nav-render-start',
  NAV_MOUNT = 'nav-mount',
  ROUTER_START = 'router-start',
  ADAPTER_EXEC_START = 'adapter-exec-start',
  ADAPTER_EXEC_COST = 'adapter-exec-cost',
  COMPONENT_RENDER_START = 'component-render-start',
  PROJECT_AUTH_ROUTER_START = 'projectAuthRouter-start',
  PROJECT_AUTH_ROUTER_COST = 'projectAuthRouter-cost',
  PROJECT_AUTH_ROUTER_INJECT_ABOUT_PROJECT_START = 'projectAuthRouter-injectAboutProject-start',
  PROJECT_AUTH_ROUTER_INJECT_ABOUT_PROJECT_COST = 'projectAuthRouter-injectAboutProject-cost',
  WORK_OBJ_AUTH_ROUTER_FOR_VIEW_START = 'workObjAuthRouterForView-start',
  WORK_OBJ_AUTH_ROUTER_FOR_VIEW_COST = 'workObjAuthRouterForView-cost',
  WORK_OBJ_AUTH_ROUTER_FOR_WORK_ITEM_START = 'workObjAuthRouterForWorkItem-start',
  WORK_OBJ_AUTH_ROUTER_FOR_WORK_ITEM_COST = 'WorkObjAuthRouterForWorkItem-cost',
  WAIT_INTERCEPTOR_READY_COST = 'wait-interceptor-ready-cost',
  WAIT_RDK_CORE_COST = 'wait-rdk-core-cost',
  WAIT_PREFETCH_WAITING_LIST_COST = 'wait-prefetch-waiting-list-cost',
  END = 'end',
}

export const recordLaunchMetrics = (key: string, metric: number) => {
  window.launchMetrics ||= {};
  if (!window.launchMetrics[key]) {
    window.launchMetrics[key] = metric;
  }
};

export const collectJsExecutionTime = (start: number, end: number) => {
  // const pp = location.protocol + __webpack_public_path__;
  // 私有化临时解决 私有化的 CDN 前缀自带协议
  const pp = __webpack_public_path__.startsWith('http')
    ? __webpack_public_path__
    : location.protocol + __webpack_public_path__;
  const entries = performance
    .getEntries()
    .filter(entry => entry.entryType === 'resource') as PerformanceResourceTiming[];
  const resourceTimings = entries
    .filter(
      entry =>
        entry.name.startsWith(pp) &&
        entry.name.includes('.js') &&
        entry.startTime >= start &&
        entry.responseEnd < end,
    )
    .sort((a, b) => a.responseEnd - b.responseEnd);

  const jsName = resourceTimings[0]?.name.replace(pp, '') ?? '';
  const fetchEnd = resourceTimings[0]?.responseEnd ?? start;
  const execTimestamp = window.JS_EXE_TIMESTAMP?.[jsName] ?? start;

  return {
    jsName,
    fetchEnd,
    execTimestamp,
  };
};

export const getJsExecutionTime = (name: string) => {
  const key = Object.keys(window.JS_EXE_TIMESTAMP ?? []).find(key => key.includes(name));
  return window.JS_EXE_TIMESTAMP?.[key];
};

export const collectJsFetchTime = (start: number, end: number) => {
  const entries = performance
    .getEntries()
    .filter(entry => entry.entryType === 'resource') as PerformanceResourceTiming[];
  const resourceTimings = entries
    .filter(
      entry => entry.name.includes('.js') && entry.startTime >= start && entry.responseEnd < end,
    )
    .sort((a, b) => a.responseEnd - b.responseEnd);
  console.log(resourceTimings);
  return resourceTimings[0]?.responseEnd ?? start;
};
